module.exports = __webpack_public_path__ + "static/media/thermage_eyes_focus.29a343f5.m4v";